import appStoreBadge from '../assets/app-store-badge.svg';
import googlePlayBadge from '../assets/google-play-badge.svg'; 
import phoneImage from "../assets/phone-no-background.png";

export default function Download() {
  return (
    <section id="download" className="section container" style={{ textAlign: 'center' }}>
    <h3>Available on iOS & Coming Soon to Android</h3>
      
      {/* 1. Main container layout is now a centered vertical stack */}
      <div 
        className="cta" 
        style={{ 
          marginTop: 24, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          gap: 20 // Space between the badge row and the button
        }}
      >
        
        {/* 2. Sub-container just for the badges to sit side-by-side and centered */}
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
          {/* Real App Store Link */}
          <a 
            href="https://apps.apple.com/app/apple-store/id6766742055?pt=128811910&ct=website&mt=8" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ display: 'inline-block' }}
          >
            <img src={appStoreBadge} alt="Download on the App Store" style={{ height: '44px', width: 'auto' }} />
          </a>
          
          {/* Real Google Play Link */}
          <a 
            href="https://play.google.com/store/apps/details?id=com.befitfriends.app" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ display: 'inline-block' }}
          >
            <img src={googlePlayBadge} alt="Download on Google Play" style={{ height: '44px', width: 'auto' }} />
          </a>
        </div>

        {/* IMAGE CONTAINER */}
      <div style={{ textAlign: "center", margin: "0 auto 1rem auto"}}>
        <img
          src={phoneImage}
          alt="BeFitFriends App Preview on App Store"
          style={{ maxWidth: "500px", width: "100%", height: "auto", display: "inline-block" }}
        />
      </div>

        
        {/* 3. Button now naturally drops to the bottom and centers */}
        {/* <a className="btn btn-primary" href="#waitlist">
          Notify me
        </a> */}
      </div>
    </section>
  );
}